<!-- Component Editor - renders a group of related properties -->
<script lang="ts">
  import { slide } from 'svelte/transition';
  import type { ComponentSchema } from '../metadata/schemas';
  import PropertyEditor from './PropertyEditor.svelte';
  import { toggleComponentCollapse, sceneState } from '../stores/sceneEditorStore';
  import Icon from '@/ui/base/Icon.svelte';

  let {
    objectId,
    object,
    component,
  }: {
    objectId: string;
    object: any;
    component: ComponentSchema;
  } = $props();

  // Проверяем, свернут ли компонент (реактивно)
  let isCollapsed = $state(false);
  $effect(() => {
    const state = $sceneState;
    const key = `${objectId}:${component.name}`;
    isCollapsed = state.collapsedComponents[key] || false;
  });

  // Реактивный заголовок кнопки
  const buttonTitle = $derived(isCollapsed ? 'Expand component' : 'Collapse component');

  // Реактивный текст заголовка компонента
  const headerText = $derived(component.displayName);

  // Реактивное условие для отображения содержимого
  const showContent = $derived(!isCollapsed);
</script>

<div class="component-editor space-y-3">
  <!-- Заголовок с кнопкой сворачивания -->
  <div class="flex items-center gap-1">
    <button
      class="p-1 rounded transition-colors group cursor-pointer"
      onclick={() => toggleComponentCollapse(objectId, component.name)}
      title={buttonTitle}
    >
      <Icon
        name={isCollapsed ? 'chevron-right' : 'chevron-down'}
        size="sm"
        class="text-gray-400 group-hover:text-white w-3 h-3 transition-colors"
      />
    </button>
    <h4 class="text-xs font-medium text-white border-b border-gray-600 pb-1 flex-1">
      {headerText}
    </h4>
  </div>

  <!-- Содержимое компонента (сворачиваемое) -->
  {#if showContent}
    <div class="space-y-3" in:slide={{ duration: 200 }} out:slide={{ duration: 200 }}>
      {#each component.properties as property (property.key)}
        <PropertyEditor {objectId} {object} {property} />
      {/each}
    </div>
  {/if}
</div>

<style>
  .component-editor {
    margin-bottom: 1rem;
  }
</style>
